import styled from 'styled-components';

const StyledContent = styled.div`
  .identity__address-title {
    margin-bottom: 24px;
  }
`;

export default StyledContent;
